import {ChangeEvent, ReactElement, useState, useContext} from 'react'
import {
  FormControl,
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Checkbox,
  FormControlLabel,
} from '@material-ui/core'
import {Trans} from 'react-i18next'

import AppContext from '../../../../../../Common/contexts/AppContext'
import messages from '../../../../../../../assets/messages'
import {CRYPTO_FIELD_NAMES, CRYPTO_DEFAULT_FIELD_VALUES} from '../../../constants'
import {useStyles} from './styles'

type CryptoFieldsProps = {
  networkOptions: {value: string, label: string}[],
  cryptoPaymentFields: Record<string, any> | null,
  onCryptoSet: (fieldValues) => void,
  onClose: () => void,
}

function CryptoFields(props: CryptoFieldsProps): ReactElement {
  const {cryptoPaymentFields, onCryptoSet, onClose, networkOptions} = props
  const {companyObject} = useContext(AppContext)
  const classes = useStyles()
  const [formFieldsValues, setFormFieldsValues] = useState(cryptoPaymentFields || CRYPTO_DEFAULT_FIELD_VALUES)
  const isSubmitDisabled = (function() {
    const isEmptyFieldPresented = Object.values(formFieldsValues).some(value => {
      if (typeof value === 'string') return !value.trim()
      return !value
    })
    const isConfirmAddressMatched = formFieldsValues.walletAddress === formFieldsValues.walletAddressConfirmation

    return !isConfirmAddressMatched || isEmptyFieldPresented
  })()

  const handleTextFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {value, name} = event.target
    setFormFieldsValues(prevValues => ({...prevValues, [name]: value}))
  }

  const handleSelectFieldChange = (event: ChangeEvent<{name?: string | undefined; value: unknown}>) => {
    const {value, name} = event.target
    if (!name || !value) return

    setFormFieldsValues(prevValues => ({...prevValues, [name]: value}))
  }

  const handleCheckboxFieldChange = (event: ChangeEvent<HTMLInputElement>) => {
    const {name} = event.target
    setFormFieldsValues(prevValues => ({...prevValues, [name]: !prevValues[name]}))
  }

  const handleSave = () => {
    onCryptoSet(formFieldsValues)
    onClose()
  }

  return (
    <>
      <FormControl fullWidth>
        <TextField
          type="text"
          name={CRYPTO_FIELD_NAMES.walletAddress}
          value={formFieldsValues.walletAddress}
          label={<Trans {...messages.walletAddress} /> }
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <TextField
          type="text"
          name={CRYPTO_FIELD_NAMES.walletAddressConfirmation}
          value={formFieldsValues.walletAddressConfirmation}
          label={<Trans {...messages.walletAddressConfirmation} /> }
          onChange={handleTextFieldChange}
        />
      </FormControl>
      <FormControl fullWidth>
        <InputLabel><Trans {...messages.network} /></InputLabel>
        <Select value={formFieldsValues.cryptoNetwork} name={CRYPTO_FIELD_NAMES.cryptoNetwork} onChange={handleSelectFieldChange}>
          {networkOptions.map(({value, label}) => <MenuItem key={value} value={value}>{label}</MenuItem>)}
        </Select>
      </FormControl>
      <FormControlLabel
        classes={{label: classes.checkboxLabel}}
        control={
          <Checkbox
            checked={formFieldsValues.walletResponsibilityConfirmation}
            name={CRYPTO_FIELD_NAMES.walletResponsibilityConfirmation}
            onChange={handleCheckboxFieldChange}
            color="primary"
          />
        }
        label={<Trans {...messages.walletResponsibilityConfirmation} values={{company: companyObject.brandLabel,}}/>}
      />
      <Button disabled={isSubmitDisabled} variant="contained" color="primary" onClick={handleSave} className={classes.button}>
        <Trans {...messages.saveAndContinue} />
      </Button>
    </>
  )
}

export {CryptoFields}
